import React, { useEffect, useState } from "react"
import { api } from "../../../services";
import ReactGA from "react-ga4";
import { Tag } from "antd";

export const PreviouslySelectedCategories = ({ modules, categories, form, onModuleChange, onCategoryChange }) => {
  const [previouslySelectedCategories, setPreviouslySelectedCategories] = useState(null)

  const fetchPreviouslySelectedCategories = async () => {
    try {
      const response = await api.Category.fetchPreviouslySelectedCategories();
      setPreviouslySelectedCategories(response)
    } catch (error) {
      setPreviouslySelectedCategories(null)
    }
  }

  useEffect(() => {
    fetchPreviouslySelectedCategories()
  }, [])


  const handleClick = (previouslySelectedCategory) => {
    ReactGA.event({
      category: "Predaja oglasa",
      action: "Click",
      label: "Odabir prethodne kategorije"
    });

    const foundModule = modules.find(module => module.name === previouslySelectedCategory.module)
    const foundCategory = categories.find(category => category.name === previouslySelectedCategory.category)

    form.setFieldsValue({ module: foundModule.route })
    onModuleChange(foundModule.route)
    form.setFieldsValue({ category: foundCategory.route })
    onCategoryChange(foundCategory.route)
  }

  return previouslySelectedCategories && previouslySelectedCategories.length > 0 ? (
    <div style={{ marginBottom: 17 }}>
      <p style={{ marginBottom: "7px", color: "#828282", fontSize: 16 }}>Tvoje prethodne kategorije:</p>
      {previouslySelectedCategories.map((category, i) => (
        <Tag
          key={`${category.categoryDisplayName}-${category.moduleDisplayName}`}
          onClick={() => handleClick(category)}
          style={{
            background: "#feecec",
            color: "#fa5659",
            border: "none",
            marginBottom: 7
          }}
        >
          {category.moduleDisplayName} {">"} {category.categoryDisplayName}
        </Tag>
      ))
      }
    </div >
  ) : null
}


// WEBPACK FOOTER //
// ./src/containers/SelectModulePage/TitleWithModule/PreviouslySelectedCategories.tsx